import { createAsyncThunk } from '@reduxjs/toolkit';

import { JsonQuery, type TJsonQuery, getGeoValueByType } from '@/packages/JsonQuery';
import { isNonEmptyArray } from '@/packages/JsonQuery/utils/isNonEmptyArray';
import { type IJsonQueryRegionalDistrict } from '@/packages/api-models/common/json_query';

import { type ISimpleGeoTag } from '@/microfrontends/filters/shared/types/geoTags';

import { updateMeta } from '../../thunks/regionalDistrictsPopup';
import { type TThunkApi } from '../../types';

interface IToggleRegionalDistrictResult {
  jsonQuery: TJsonQuery;
  geoTagsRegionalDistricts: ISimpleGeoTag[];
}

export const toggleRegionalDistrict = createAsyncThunk<IToggleRegionalDistrictResult, number, TThunkApi>(
  'regionalDistrictsPopup/toggleRegionalDistrict',
  async (id, thunkApi) => {
    const { getState, dispatch } = thunkApi;

    const state = getState();
    const jsonQuery = state.regionalDistrictsPopup.jsonQuery;
    const geoTagsRegionalDistrictsNext = [...state.regionalDistrictsPopup.geoTags.regionalDistrict];

    const nextJsonQuery = new JsonQuery(jsonQuery);
    const selectedDistricts: IJsonQueryRegionalDistrict[] =
      getGeoValueByType<IJsonQueryRegionalDistrict>('regional_district_id')(jsonQuery) || [];

    if (selectedDistricts.some(item => item.id === id)) {
      nextJsonQuery.removeGeo({ type: 'regional_district_id', id });
    } else {
      // Обновляем jsonQuery, здесь нужно добавить новый район загородки в geo
      selectedDistricts.push({ type: 'regional_district_id', id });

      // Здесь на самом деле всегда будет true, потому что мы добавляем хотя бы один элемент,
      // проверка нужна для правильной типизации
      if (isNonEmptyArray(selectedDistricts)) {
        nextJsonQuery.setRegionalDistricts(...selectedDistricts);
      }

      // Добавляем данные для гео тегов. Если такого района ещё не было, нужно сохранить его название.
      const hasRegionalDistrictTag = !!geoTagsRegionalDistrictsNext.find(item => item.id === id);
      if (!hasRegionalDistrictTag) {
        const district = state.regionalDistrictsPopup.districts.find(item => item.id === id);

        if (district) {
          geoTagsRegionalDistrictsNext.push({
            type: 'regionalDistrict',
            id: district.id,
            name: district.name,
          });
        }
      }
    }

    const nextJsonQuerySerialized = nextJsonQuery.toJSON();

    // специально не блокируемся об получение мета
    dispatch(updateMeta(nextJsonQuerySerialized));

    return {
      geoTagsRegionalDistricts: geoTagsRegionalDistrictsNext,
      jsonQuery: nextJsonQuerySerialized,
    };
  },
);
